import {
  Crown,
  Gift,
  Others,
  Support,
  Contact,
  Profile,
  Seven,
  DropLines,
  W,
  Calendar,
  Ticket,
  Pinball,
  HuntTracker,
  GamdomIcon,
  Target,
} from "./components/icons";
import News from "assets/icons/news.svg";
import { Swords } from "lucide-react";
import { ReactNode } from "react";

export const menuItems: ITopMenuItem[] = [
  {
    name: "Leaderboard",
    href: "/leaderboards",
    isInteractive: true,
    image: <Crown />,
  },
  {
    name: "All bonuses",
    href: "/all-bonuses",
    isInteractive: true,
    image: <Gift />,
  },

  {
    name: "Free Spins Calendar",
    href: "/advent-calendar",
    image: <Calendar />,
    isInteractive: true,
  },
  {
    name: "Tournaments",
    href: "/tournaments",
    image: <Swords />,
    isInteractive: true,
  },

  {
    name: "Challenges",
    href: "/challenges",
    image: <Target />,
    isInteractive: true,
  },

  {
    name: "Gamdom bonuses",
    href: "/gamdom-bonuses",
    isInteractive: true,
    image: <GamdomIcon />,
  },

  {
    name: "Rewards",
    image: <W />,
    items: [
      {
        name: "Raffles",
        href: "/raffles",
        image: <Ticket />,
      },
      {
        name: "Points Shop",
        href: "/points-shop",
        image: <W />,
      },
      {
        name: "Pachinko",
        href: "/pachinko",
        image: <Pinball />,
      },
    ],
  },
  {
    name: "Others",
    image: <Others />,
    items: [
      {
        name: "Hunt Tracker",
        href: "/hunt-tracker",
        image: <HuntTracker />,
      },
    ],
  },
];

export const addMenuItems: ITopMenuItem[] = [
  {
    name: "Support",
    href: "/faq",
    image: <Support />,
  },
  {
    name: "Contact",
    href: "/contact-us",
    image: <Contact />,
  },
];

export const metaMenuItems: ITopMenuItem[] = [
  {
    name: "Privacy Policy",
    href: "/privacy-policy",
  },
  {
    name: "Terms of Service",
    href: "/terms-of-service",
  },
];
export interface ITopMenuItem {
  name: string;
  href?: string;
  type?: string;
  image?: ReactNode;
  isMobileOnly?: boolean;
  isDesktopOnly?: boolean;
  isInteractive?: boolean;
  items?: ITopMenuItem[];
}
export interface IMobileMenuItem {
  name: string;
  icon?: (isActive: boolean) => JSX.Element;
}

export const metaMobileMenuItems: IMobileMenuItem[] = [
  {
    name: "browse",
    icon: (isActive: boolean) => (
      <DropLines fill={isActive ? "var(--pure-sky)" : "var(--clouds-100)"} />
    ),
  },
  {
    name: "games",
    icon: (isActive: boolean) => (
      <Seven fill={isActive ? "var(--pure-sky)" : "var(--clouds-100)"} />
    ),
  },
  {
    name: "bonuses",
    icon: (isActive: boolean) => <Gift fill={isActive ? "var(--pure-sky)" : "var(--clouds-100)"} />,
  },
  {
    name: "news",
    icon: (isActive: boolean) => <News fill={isActive ? "var(--pure-sky)" : "var(--clouds-100)"} />,
  },
  {
    name: "profile",
    icon: (isActive: boolean) => (
      <Profile fill={isActive ? "var(--pure-sky)" : "var(--clouds-100)"} />
    ),
  },
];
